module.exports = __webpack_public_path__ + "static/media/fa-regular-400.95f13e0b.svg";